<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid lk-eu-mobile-form-fields">
          <div class="field">
            <label class="font-medium required-field">Email</label>
            <crm-input-text
              [(value)]="profile.email"
              [disabled]="loadingProfile"
              [isError]="$any(profileError?.email)"
              (onBlur)="changeEmail(profile.email)"></crm-input-text>
            <small
              *ngIf="profileError?.email"
              class="p-error">
              {{ profileError?.email | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Имя</label>
            <crm-input-text
              [(value)]="profile.firstName"
              [disabled]="loadingProfile"
              [isError]="$any(profileError?.firstName)"></crm-input-text>
            <small
              *ngIf="profileError?.firstName"
              class="p-error">
              {{ profileError?.firstName | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Фамилия</label>
            <crm-input-text
              [(value)]="profile.lastName"
              [disabled]="loadingProfile"
              [isError]="$any(profileError?.lastName)"></crm-input-text>
            <small
              *ngIf="profileError?.lastName"
              class="p-error">
              {{ profileError?.lastName | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Отчество</label>
            <crm-input-text
              [(value)]="profile.middleName"
              [disabled]="loadingProfile"
              [isError]="$any(profileError?.middleName)"></crm-input-text>
            <small
              *ngIf="profileError?.middleName"
              class="p-error">
              {{ profileError?.middleName | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Телефон</label>
            <p-inputMask
              type="text"
              mask="+9 (999) 999-99-99"
              placeholder="+7 (999) 999-99-99"
              [unmask]="true"
              [(ngModel)]="profile.phone"
              [disabled]="loadingProfile"
              [ngClass]="{ 'ng-invalid ng-dirty': profileError?.phone }">
            </p-inputMask>
            <small
              *ngIf="profileError?.phone"
              class="p-error">
              {{ profileError?.phone | join }}
            </small>
          </div>
        </div>
      </p-card>

      <crm-lk-eu-access-control-widget
        styleClass="mt-3"
        [user]="$any(user)"
        (accessChange)="user.accessControl = $event.accessControl"></crm-lk-eu-access-control-widget>
    </div>
  </div>

  <div class="mt-3">
    <crm-button
      [label]="saveButtonLabel"
      styleClass="p-button-success"
      (onClick)="saveUser()"></crm-button>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
